import React from 'react'

import Navbar from '../components/Navbar/Navbar'
import SalesPage from '../components/Navbar/SalesPage'

function salespage() {
  return (
    <>
      <Navbar />
      <SalesPage></SalesPage>
    </>
  )
}

export default salespage
